import React from "react"
import NumberFormat from "react-number-format"
import { API_SERVER } from "../../../restClient"

const Currency = ({ value, unit }) => {
  let unitDefault = "Rp "
  if (API_SERVER.includes("luveshop.com")) {
    unitDefault = "RM "
  }
  const prefix = unit || unitDefault
  return (
    <NumberFormat
      displayType="text"
      thousandSeparator={"."}
      decimalSeparator={","}
      prefix={prefix}
      value={value}
    />
  )
}

export default Currency



// WEBPACK FOOTER //
// ./src/editor/components/productcard/Currency.js